function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.45193 8.5144V22H18.7116V8.5144",
  stroke: "currentColor",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5385 8.9231V22",
  stroke: "currentColor",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.7692 8.9231V22",
  stroke: "currentColor",
  strokeWidth: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("mask", {
  id: "path-4-inside-1",
  fill: "white"
}, /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 4.25247,
  width: 16.8132,
  height: 4.67033,
  rx: 1
}));

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 4.25247,
  width: 16.8132,
  height: 4.67033,
  rx: 1,
  stroke: "currentColor",
  strokeWidth: 3,
  mask: "url(#path-4-inside-1)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M15.0337 4.45192V3C15.0337 2.44772 14.586 2 14.0337 2H11.1298C10.5775 2 10.1298 2.44772 10.1298 3V4.45192",
  stroke: "currentColor",
  strokeWidth: 1.5
});

const SvgTrash = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTrash, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Trash.ed754729.svg";
export { ForwardRef as ReactComponent };